<script lang="ts">
    export let value: string;
    export let disabled: boolean = false;
    export let onChange: (value: string) => void;

    function handleChange(event: Event) {
        const target = event.target as HTMLTextAreaElement;
        onChange(target.value);
    }
</script>

<textarea class="settings-value" bind:value {disabled} on:change={handleChange} />

<style>
    .settings-value {
        flex: 1 1 auto;
        box-sizing: border-box;
        /*width: 100%;*/
        padding: var(--input-small-padding);
        /*margin: 0 3px;*/
        background-color: #ffffff;
        border: var(--input-small-border);
        border-radius: var(--input-small-border-radius);
        font-family: inherit;
        font-size: var(--input-small-font-size);
        min-height: 90px;
        color: var(--input-small-color);
        /*wid*/
    }
</style>
